import React from 'react'
import { Helmet } from 'react-helmet-async'

function Genralinsurance() {
  return (
   <div className="w-full min-h-screen bg-gray-100 p-4">
          <Helmet>
                 <title>Kota HOLDINGS</title>
                 <meta name="description" content="A Vision of My 30-Year World" />
               </Helmet>
         <div className="mx-auto bg-white shadow-lg rounded-lg overflow-hidden">
           <div className="bg-[#FF6F00] text-white p-6">
             <h2 className="text-2xl font-bold">We provide the best value General Insurance</h2>
             <p className="mt-2">Simple steps you can take to improve your financial well-being for the rest of your life.</p>
             <div className="mt-4 grid grid-cols-1 md:grid-cols-3 gap-4">
               <input type="text" placeholder="Your Name" className="p-2 rounded-md text-black" />
               <input type="tel" placeholder="+91 Phone" className="p-2 rounded-md text-black" />
               <input type="email" placeholder="Email" className="p-2 rounded-md text-black" />
             </div>
             <textarea placeholder="Message" className="w-full mt-4 p-2 rounded-md text-black"></textarea>
             <button className="mt-4 bg-blue-600 hover:bg-blue-900 text-white px-6 py-2 rounded-md">Get Quote</button>
           </div>
           <div className="p-6">
             <h1 className="text-2xl md:text-3xl font-bold text-[#FF6F00] mb-4">What is General Insurance?</h1>
                  <p className="mb-4">General insurance is like a shield for things other than you health life. It covers you car,home
                      ,travel and more. If some bad happens,like an accident,theft,or damage, the insurance company help you pay for the repair or replacements.
             </p>
             <h2 className="text-xl font-bold mt-6 mb-2">Types Of General Insurance:</h2>
             <ul className="list-disc list-inside mb-4">
                      <li><strong>Motor Insurance:</strong>Motor insurance is coverage for your vechile, protectinf you from financail
                      losses due to accidents,theft or damage.</li>
                      <li><strong>Health Insurnace :</strong> Health insurance covers your medical expenses, helping
                          you afford healthcare services and treatments when you're sick or injured.</li>
               <li><strong>Travel Insurnace:</strong> Travel insurance offers coverage for unexpected events during your trips, including trip cancellations, medical emergencies, lost luggage, and more.</li>
               <li><strong>Home Insurance:</strong> Home insurance provides financial protection for your home and belongings against events like theft, fire, and natural disasters.</li>
               <li><strong>Marine Insurance:</strong> Marine insurance covers losses and damages to ships and cargo during sea voyages, providing financial protection for maritime activities.</li>
               <li><strong>Rural Insurance:</strong> Rural insurance provides coverage for agricultural assets, livestock, and rural properties, protecting farmers and rural communities from financial losses due to various risks.</li>
               <li><strong>Mobile Insurance:</strong> Mobile insurance covers the cost of repairing or replacing your smartphone if it gets damaged, stolen, or lost.</li>
               <li><strong>Bicycle Insurance:</strong> Bicycle insurance provides coverage for your bicycle against theft, damage, and accidents.</li>
               <li><strong>Commercial Insurance:</strong> Commercial insurance is coverage for businesses, safeguarding them from financial losses due to property damage, liability, business interruptions, and other risks specific to their industry and operations.</li>
             </ul>
             
             <h2 className="text-xl font-bold mt-6 mb-2">Learn a few terms about General Insurance</h2>
             <ul className="list-disc list-inside mb-4">
               <li>Regular payment for the policy.</li>
               <li>Beneficiary who receives the death benefit.</li>
               <li>Payout given upon insured's passing.</li>
               <li>Policy duration and validity.</li>
               <li>Sum of money paid to the beneficiary.</li>
               <li>Risk assessment for policy eligibility.</li>
               <li>Savings component that grows over time.</li>
               <li>Optional add-ons for extra coverage.</li>
               <li>Coverage for a specific period with lower premiums.</li>
               <li>Lifetime coverage with savings benefits.</li>
             </ul>
           </div>
         </div>
       </div>
  )
}

export default Genralinsurance